import { Grid, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import TextField from '../../../components/Form/TextField'
import { useAuth } from '../../../hooks/auth'
import utilsDate from '../../../utils/Date'
import { useStyles } from '../Style'
import SelectStatus from './SelectStatus'
type props = any;

const MvmGeneralInfo: React.FC<props> = ({ mvm, edit, control, setValue }) => {

    const classes = useStyles();
    const { t: tMvm } = useTranslation("Mvm")
    const { t: tGeneral } = useTranslation("General")
    const { isMopar } = useAuth()
    useEffect(() => {
        
        if(!mvm)
            return

        setValue("entryConcierge", mvm.conciergeCode)
        setValue("entranceDate", mvm.entranceDate)
        setValue("entranceUser", mvm.entranceUser)
        setValue("entranceUserName", mvm.entranceUserName)
        setValue("exitDate", mvm.exitDate)
        setValue("submitDate", mvm.submitDate)
        setValue("systemS881Return", mvm.s881ReturnDescription)
        setValue("exitUser", mvm.exitUser)
        setValue("exitUserName", mvm.exitUserName)
        setValue("createdBy", mvm.createdBy)
        setValue("status", {code: mvm.status, label: mvm.statusDescription})
        setValue("statusView", mvm.statusDescription)
        setValue("scheduleDate", mvm.scheduleDate)
        setValue("entryAuthorizationDate", mvm.entryAuthorizationDate)
        setValue("conciergeReleaseDate", mvm.conciergeReleaseDate)
        setValue("deliveryWindowDate", mvm.deliveryWindowDate)
        setValue("rackDispatchReturnDescription", mvm.rackDispatchReturnDescription)
        setValue("scheduleUser", mvm.scheduleUser)
        setValue("windowStatus", mvm.windowStatus)
        setValue("deliveryWindowDate", mvm.deliveryWindowDate)
        setValue("windowId", mvm.windowId)
        setValue("unforeseenReason", mvm.unforeseenReason)
        setValue("presentationPlantDate", mvm.presentationPlantDate)
        setValue("conciergeReleaseDate", mvm.conciergeReleaseDate)
        setValue("conciergeReleaseUser", mvm.conciergeReleaseUser)
        setValue("criticalMaterialCallDate", mvm.criticalMaterialCallDate)
        setValue("criticalMaterialCallUser", mvm.criticalMaterialCallUser)
        setValue("entryAuthorizationDate", mvm.entryAuthorizationDate)
        setValue("entryAuthorizationUser", mvm.entryAuthorizationUser)
        setValue("vehicleReleaseDateWithInvoice", mvm.vehicleReleaseDateWithInvoice ? utilsDate.DateTimeShort(mvm.vehicleReleaseDateWithInvoice) : '')
        setValue("releasedFCADate", mvm.releasedFCADate ? utilsDate.DateTimeSecond(mvm.releasedFCADate) : '')
        setValue("releasedFCAUser", mvm.releasedFCAUser)
        setValue("releasedFCAUserName", mvm.releasedFCAUserName)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mvm])
  
    return (
        <Grid style={{ marginTop: 20, width: "98%", marginBottom: 10 }}>
            <Typography className={classes.root} style={{ marginLeft: 10 }} >
                {tMvm("generalInfo")}
            </Typography>
            <Grid container spacing={1} >
                {edit === true ?
                    <Grid item xs={5}>
                        <SelectStatus 
                            name="status" 
                            context="AEStatusMVM"
                            label={tMvm('status')} 
                            control={control} 
                            fullWidth  />
                    </Grid>
                    :
                    <Grid item xs={2}>
                        <TextField 
                            label={tMvm("status")} 
                            name="statusView" 
                            control={control}
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: !edit,
                                classes: {
                                    input: edit ? classes.rootTextBox : classes.inputBlocked
                                }
                            }}/> 
                    </Grid>
                }
            </Grid>
            <Grid container spacing={1} >

                <Grid item xs={2}>
                    <TextField
                        label={tMvm("submitDate")}
                        name="submitDate"
                        control={control} 
                        fullWidth
                        type="datetime-local"
                        InputLabelProps={{shrink:true}}
                        InputProps={{
                            readOnly: true,
                            classes: {
                                input: classes.inputBlocked
                            }
                        }}/> 
                </Grid>                

                {!edit &&
                    <>
                        <Grid item xs={2}>
                            <TextField
                                label={tMvm("presentationPlantDate")}
                                name="scheduleDate"
                                control={control} 
                                fullWidth
                                type={mvm.scheduleDate || edit ? "datetime-local" : "text"}
                                InputLabelProps={{shrink:true}}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }}/> 
                        </Grid>

                        <Grid item xs={2}>
                            <TextField
                                label={tMvm("entryAuthorizationDate")}
                                name="entryAuthorizationDate"
                                control={control} 
                                fullWidth
                                type={mvm.entryAuthorizationDate || edit ? "datetime-local" : "text"}
                                InputLabelProps={{shrink:true}}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }}/> 
                        </Grid>


                        <Grid item xs={2}>
                            <TextField
                                label={tMvm("conciergeReleaseDate")}
                                name="conciergeReleaseDate"
                                control={control} 
                                fullWidth
                                type={mvm.conciergeReleaseDate || edit ? "datetime-local" : "text"}
                                InputLabelProps={{shrink:true}}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }}/> 
                        </Grid>
                    </>
                }
                <Grid item xs={2}>
                    <TextField
                        label={tMvm("entranceDate")}
                        name="entranceDate"
                        control={control} 
                        fullWidth
                        type={mvm.entranceDate || edit ? "datetime-local" : "text"}
                        InputLabelProps={{shrink:true}}
                        InputProps={{
                            readOnly: !edit,
                            classes: {
                                input: edit ? classes.rootTextBox : classes.inputBlocked
                            }
                        }}/> 
                </Grid>
                
                <Grid item xs={2}>
                    <TextField
                        label={tMvm("exitDate")}
                        name="exitDate"
                        control={control} 
                        fullWidth
                        type={mvm.exitDate || edit ? "datetime-local" : "text"}
                        InputLabelProps={{shrink:true}}
                        InputProps={{
                            readOnly: !edit,
                            classes: {
                                input: edit ? classes.rootTextBox : classes.inputBlocked
                            }
                        }}/> 
                </Grid>
                
                <Grid item xs={2}>
                    <TextField 
                        label={tMvm("entryConcierge")} 
                        name="entryConcierge" 
                        control={control}
                        fullWidth
                        InputLabelProps={{shrink:true}}
                        InputProps={{
                            readOnly: !edit,
                            classes: {
                                input: edit ? classes.rootTextBox : classes.inputBlocked
                            }
                        }}/> 
                </Grid>

                {!edit &&
                    <>
                    
                        <Grid item xs={2}>
                            <TextField
                                label={tMvm("deliveryWindowDate")}
                                name="deliveryWindowDate"
                                control={control} 
                                fullWidth
                                type={mvm.deliveryWindowDate || edit ? "datetime-local" : "text"}
                                InputLabelProps={{shrink:true}}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }}/> 
                        </Grid>

                        <Grid item xs={2}>
                            <TextField
                                label={tMvm("windowStatus")}
                                name="windowStatusDescription"
                                control={control} 
                                fullWidth
                                InputLabelProps={{shrink:true}}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }}/> 
                        </Grid>

                        
                        </>
                }

                <Grid item xs={2}>
                    <TextField
                        label={tMvm("vehicleDateReleaseWithNF")}
                        name="vehicleReleaseDateWithInvoice"
                        control={control} 
                        fullWidth
                        InputLabelProps={{shrink:true}}
                        InputProps={{
                            readOnly: !edit,
                            classes: {
                                input: edit ? classes.rootTextBox : classes.inputBlocked
                            }
                        }}/> 
                </Grid>

            </Grid>
            <Grid container spacing={1} >

                <Grid item xs={2}>
                    <TextField
                        label={tGeneral("createdBy")}
                        name="createdBy"
                        control={control} 
                        fullWidth
                        InputLabelProps={{shrink:true}}
                        InputProps={{
                            readOnly: !edit,
                            classes: {
                                input: edit ? classes.rootTextBox : classes.inputBlocked
                            }
                        }}/> 
                </Grid>

                <Grid item xs={2}>
                    <TextField
                        label={tMvm("entranceUserName")}
                        name="entranceUserName"
                        control={control} 
                        fullWidth
                        InputLabelProps={{shrink:true}}
                        InputProps={{
                            readOnly: !edit,
                            classes: {
                                input: edit ? classes.rootTextBox : classes.inputBlocked
                            }
                        }}/> 
                </Grid>
                
                <Grid item xs={2}>
                    <TextField
                        label={tMvm("entranceUser")}
                        name="entranceUser"
                        control={control} 
                        fullWidth
                        InputLabelProps={{shrink:true}}
                        InputProps={{
                            readOnly: !edit,
                            classes: {
                                input: edit ? classes.rootTextBox : classes.inputBlocked
                            }
                        }}/> 
                </Grid>

                <Grid item xs={2}>
                    <TextField
                        label={tMvm("exitUserLogin")}
                        name="exitUserName"
                        control={control} 
                        fullWidth
                        InputLabelProps={{shrink:true}}
                        InputProps={{
                            readOnly: !edit,
                            classes: {
                                input: edit ? classes.rootTextBox : classes.inputBlocked
                            }
                        }}/> 
                </Grid>

                <Grid item xs={2}>
                    <TextField
                        label={tMvm("exitUserName")}
                        name="exitUser"
                        control={control} 
                        fullWidth
                        InputLabelProps={{shrink:true}}
                        InputProps={{
                            readOnly: !edit,
                            classes: {
                                input: edit ? classes.rootTextBox : classes.inputBlocked
                            }
                        }}/> 
                </Grid>
                
                { isMopar() && <>
                    <Grid item xs={2}>
                        <TextField
                            label={tMvm("releasedFCADate")}
                            name="releasedFCADate"
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: !edit,
                                classes: {
                                    input: edit ? classes.rootTextBox : classes.inputBlocked
                                }
                            }}/> 
                    </Grid>
                   
                    <Grid item xs={2}>
                        <TextField
                            label={tMvm("releasedFCAUser")}
                            name="releasedFCAUser"
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: !edit,
                                classes: {
                                    input: edit ? classes.rootTextBox : classes.inputBlocked
                                }
                            }}/> 
                    </Grid>

                    <Grid item xs={2}>
                        <TextField
                            label={tMvm("releasedFCAUserName")}
                            name="releasedFCAUserName"
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: !edit,
                                classes: {
                                    input: edit ? classes.rootTextBox : classes.inputBlocked
                                }
                            }}/> 
                    </Grid>
                </> }
            </Grid>
        </Grid>
    )
}

export default MvmGeneralInfo

